import FormattedAddress from "components/Atoms/FormattedAddress";
import React from "react";
import { isAdminAndVisitingAddressSame } from "shared/utils/companyUtils";
import { CompanyFormState } from "shared/utils/fieldsHelper/companyFields";
interface Props {
  companyFormState: CompanyFormState;
}

export const VisitingAddress = ({ companyFormState }: Props) => {
  return <div>
    <div>{companyFormState.name}</div>
    <FormattedAddress address={companyFormState.address.visitingAddress.dto} />
  </div>;
}

export const PostalAddress = ({ companyFormState }: Props) => {
  const isSameAsVisitingAddress = isAdminAndVisitingAddressSame(companyFormState);
  if (isSameAsVisitingAddress) {
    return <>{RESX.Company.SameAsVisitingAddress}</>;
  }

  return <div>
    <div>{companyFormState.admName}</div>
    <FormattedAddress address={companyFormState.address.postalAddress.dto} />
  </div>
};